import type { RouteRecordRaw } from 'vue-router';
import { ExpertAdviceType } from '../enums/expert-advice-type.enum';

const routes: RouteRecordRaw[] = [
  {
    name: 'plans',
    path: '/plans',
    component: () => import('../pages/PlansPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'planDetails',
    path: '/plans/:planId',
    component: () => import('../pages/PlanDetailsPage.vue'),
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'planWizard',
    path: '/plans/wizard',
    component: () => import('../pages/PlanWizardPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'expertAdvice',
    path: '/expert-advice',
    component: () => import('../pages/ExpertAdviceTypeChooserPage.vue'),
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'expertAdvicePrecision',
    path: '/expert-advice/precision',
    component: () => import('../pages/ExpertAdvicePage.vue'),
    props: { level: ExpertAdviceType.PRECISION },
    meta: {
      requiresAuth: true
    }
  },
  {
    name: 'expertAdviceParcel',
    path: '/expert-advice/parcel',
    component: () => import('../pages/ExpertAdvicePage.vue'),
    props: { level: ExpertAdviceType.PARCEL },
    meta: {
      requiresAuth: true
    }
  }
];

export default routes;
